import { render } from "./WenxinQianfanBotSettings.vue?vue&type=template&id=014cdb16"
import script from "./WenxinQianfanBotSettings.vue?vue&type=script&lang=js"
export * from "./WenxinQianfanBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__